import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DepositDetailSection from "../sections/DepositDetailSection";

const DepositDetail = () => {
  const { t } = useTranslation("shared\\moduleNames");
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <Header
        title={t("deposits.detailTitle")}
        includeBreadcrumbs
        links={[{ text: t("deposits.title"), to: "/deposits" }]}
      />
      <ModuleContent>
        <DepositDetailSection depositId={id} />
      </ModuleContent>
    </>
  );
};

export default DepositDetail;
